module.exports = __webpack_public_path__ + "img/arrows-move.545246ec.svg";